module.exports = __webpack_public_path__ + "img/logo_dk_mark@3x.b801eebf.png";